import React, { useState, useEffect } from 'react';
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useForm, Controller } from "react-hook-form";

import DialogTitle from "../../../../Common/UI/Dialog/DialogTitle";
import Spinner from "../../../../Common/UI/Spinner/Spinner";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import * as UserApi from '../../../../Common/Apis/UserApi';

const RoleNameEdit = ({ isShow, item, onClose, onRefresh }) => {
  const { showSuccess } = useNotification();

  const [isLoading, setIsLoading] = useState(false);

  const { control, handleSubmit, setValue, formState: { errors } } = useForm({
    defaultValues: {
      txtRoleName: item?.RoleName || ""
    }
  });

  const updateRoleName = async (data) => {
    try {
      setIsLoading(true);

      if (item.RoleId === "") {
        // dummy item -> create a new role
        await UserApi.createUserRole({ RoleName: data.txtRoleName });
      } else {
        await UserApi.updateUserRole(item.RoleId, { RoleName: data.txtRoleName });
      }

      showSuccess({ content: "Successfully saved", timeout: 3000 });
      setIsLoading(false);
      onRefresh();
      onClose();
    } catch (err) {
      console.log("err", err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (item) {
      setValue("txtRoleName", item.RoleName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog"
        open={isShow}
        PaperProps={{ style: { borderRadius: "1rem", margin: 20 } }}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          {item?.RoleId !== "" ? "Edit" : "Add"} Role
        </DialogTitle>
        <MuiDialogContent dividers style={{ padding: 0 }}>
          <form onSubmit={handleSubmit(updateRoleName)}>
            <div className="modal-content model-dialog">
              <div className="modal-body  pt-0 pb-0">
                <div className="row mt-3 mb-5">
                  <div className="col-12">
                    <div className="p-number">
                      <Controller
                        name="txtRoleName"
                        rules={{ required: true }}
                        control={control}
                        render={({ field }) => <TextField
                          {...field}
                          style={{ width: "100%" }}
                          label=""
                          variant="outlined"
                          size="small"
                          error={!!errors.txtRoleName}
                          helperText={""}
                        />}
                      />
                    </div>
                    <span className="p-num-span mr-2">Role Name</span>
                    {errors.txtRoleName && (
                      <p className="text-danger2">should not be blank</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </MuiDialogContent>
        <MuiDialogActions style={{ margin: 0, padding: 8 }}>
          <Button
            className="mb-3"
            style={{ fontWeight: "600" }}
            variant="contained"
            onClick={handleSubmit(updateRoleName)}
            color="primary"
          >
            Save
          </Button>
        </MuiDialogActions>
      </Dialog>
      {isLoading && <Spinner />}
    </>
  );
};

export default RoleNameEdit;
